import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap";

/**
 * @param {{id: any, name: string }[]} options - Array of options
 * @param {id} selectedOption - Selected option's Id
 * @param {function} selectOption - function to select the option
 * @param {boolean} isLoading - Shows a spinner in the menu instead of the empty state while options are being fetched
 */
const CustomDropdown = ({
  options,
  selectedOption,
  selectOption,
  defaultValue = "",
  disabled = false,
  onChanged,
  renderAnyThing = () => null,
  matchWithOther = [],
  additionalContent,
  isLoading = false,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggle = () => {
    if (!disabled) setDropdownOpen((prevState) => !prevState);
  };
  useEffect(() => {
    if (onChanged) {
      onChanged(dropdownOpen);
    }
  }, [dropdownOpen]);
  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className="select-common-dropdown"
    >
      <DropdownToggle caret={false} className="selected-item" tag="div">
        <span>
          {additionalContent && <span>{additionalContent}</span>}
          {selectedOption || matchWithOther.includes(selectedOption)
            ? options?.find((op) => op?.id == selectedOption)?.name ||
              defaultValue
            : defaultValue}
        </span>
        <img src={require("assets/images/caret.svg").default} alt="caret" />
      </DropdownToggle>

      <DropdownMenu end>
        {isLoading ? (
          <div className="d-flex justify-content-center py-2">
            <Spinner animation="border" size="sm" className="loader-spinner" />
          </div>
        ) : options?.length ? (
          options?.map((op) => {
            const { id, name } = op;
            return (
              <DropdownItem
                key={id}
                onClick={() => selectOption(id, name)}
                disabled={disabled}
              >
                <span>
                  {renderAnyThing(id)}
                  {name}
                </span>
              </DropdownItem>
            );
          })
        ) : (
          <span>Not Found</span>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CustomDropdown;
